import ButtonGroup from "@mui/joy/ButtonGroup";
import IconButton from "@mui/joy/IconButton";
import Tooltip from "@mui/joy/Tooltip";
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import WarningDialog from "@components/dialogs/WarningDialog";
import ConfigureWidget from "./ConfigureWidget";

const simulateMouseUp = (fn) => {
    setTimeout(() => {
        fn();
    }, 200);
}

export default function WidgetButtons({
    floating = false,
    isEditing = false,
    onEdit = ()=>{},
    onRemove = ()=>{},
    widget = null,
    updateWidget = null,
}) {
    if(!isEditing) {
        // return null
    }

    return (
    <ButtonGroup
        size="sm"
        spacing={0.1}
        variant="plain"
        sx={[
            floating ? {} : {
                '--IconButton-size': '8px',
                marginRight: '-0.3rem' ,
                transition: 'var(--mm-default-transition)',
            },
            !isEditing ? {
                opacity: 0,
                pointerEvents: 'none',
            } : {}
        ]}
    >
        <ConfigureWidget
            widget={widget}
            updateWidget={updateWidget}
            activateButton={(btnProps)=>
                <Tooltip title="Edit Widget">
                    <IconButton
                        // we have to override the click event
                        // onMouseDown={(e) => simulateMouseUp(()=>onEdit(e))}
                        onMouseDown={(e) => simulateMouseUp(()=>btnProps.onClick())}
                        size="sm"
                        sx={{
                            transition: 'var(--mm-default-transition)',
                            '--IconButton-size': '1.8rem',
                            ':not(:hover)': {
                                opacity: 0.6
                            },
                            ':hover': {
                                '--variant-plainHoverBg': 'var(--joy-palette-neutral-200)',
                                // var(--variant-plainHoverBg, var(--joy-palette-neutral-plainHoverBg, var(--joy-palette-neutral-100, #F0F4F8)))
                            }
                        }}
                    >
                        <SettingsRoundedIcon />
                    </IconButton>
                </Tooltip>
            }
        />

        <WarningDialog
            title="Confirm Delete"
            content={<>Are you sure you want to delete this widget?</>}
            confirmText="Delete"
            onConfirm={onRemove}
            activateButton={(btnProps)=>
                <Tooltip title="Remove Widget" color='danger'>
                    <IconButton
                        // we have to override the click event
                        onMouseDown={(e) => simulateMouseUp(()=>btnProps.onClick())}
                        size="sm"
                        color='danger'
                        sx={{
                        transition: 'var(--mm-default-transition)',
                        '--IconButton-size': '1.8rem',
                        ':not(:hover)': {
                            '--Icon-color': 'var(--joy-palette-text-icon)',
                            opacity: 0.6
                        },
                    }}>
                        <DeleteRoundedIcon />
                    </IconButton>
                </Tooltip>
            }
        />
    </ButtonGroup>
    );
}
